import FreightForwarderRules from ".";

export const freightForwarderRules = [
  {
    path: "/freightForwarderRules",
    element: <FreightForwarderRules />,
  },
];
